<template>
    <!--<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">-->
    <div class="md-layout-item md-medium-size-100 md-xlarge-size-50">
        <h3>Address</h3>

        <p class="margin_bottom">Search with postcode lookup, and confirm <b>complete</b> street address</p>

        <div class="md-layout-item md-small-size-100 md-medium-size-50 company-address">

            <zoom-center-transition :duration="2700">
                <div class="md-layout md-gutter" v-show="addressVisible">
                    <label class="md-layout-item md-size-25 md-form-label">
                        Name
                    </label>
                    <div class="md-layout-item">
                        <md-field>
                            <md-input disabled title="Not editable" v-model="name" type="text"></md-input>
                        </md-field>
                    </div>
                </div>
            </zoom-center-transition>

            <zoom-center-transition :duration="2700">
                <div class="md-layout md-gutter" v-show="addressVisible">
                    <label class="md-layout-item md-size-25 md-form-label">
                        Address
                    </label>
                    <div class="md-layout-item">
                        <ValidationProvider name="Address" rules="required|min:6" v-slot="{ passed, failed }">
                            <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                <md-textarea v-model="address.text" md-autogrow autocomplete="new-address"></md-textarea>
                                <span class="md-helper-text">Street address (excluding name)</span>
                                <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                            </md-field>
                        </ValidationProvider>
                    </div>
                </div>
            </zoom-center-transition>


            <div class="md-layout md-gutter">
                <label class="md-layout-item md-size-25 md-form-label">
                    Postcode
                </label>
                <div class="md-layout-item">
                    <div class="md-layout">
                        <ValidationProvider ref="validationProviderPostcode" name="Postcode"
                                            rules="required|min:5|max:8|regex:^[A-Za-z0-9 ]+$" v-slot="{ passed, failed }">
                            <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                <md-input type="text" v-model="address.postcode" autocomplete="new-postcode"></md-input>
                                <span class="md-helper-text">Search for Address</span>
                                <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                            </md-field>
                        </ValidationProvider>
                        <zoom-center-transition :duration="1000">
                            <div class="md-layout-item" v-show="postCodeCorrect">
                                <md-button class="md-raised md-info" title="Search For Address"
                                           @click="geocode">
                                    <md-icon>search</md-icon>
                                    Search
                                </md-button>
                            </div>
                        </zoom-center-transition>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, min, max, regex } from "vee-validate/dist/rules";//import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";?
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("regex", regex);

    import Api from '@/ts/UvApiService';
    import NotyTypes from "@/ts/NotyTypes";
    import GeocoderResults from "@/ts/GeocoderResults";

    export default {
        name: "CompanyAddress",
        components: {
            SlideYDownTransition,
            ZoomCenterTransition
        },
        props: {
            address: {
                postcode: null,
                text: null,
            },
            location: {
                lat: null,
                lng: null,
            },
            name: null
        },
        data() {
            return {
                postCodeCorrect: false,
                addressVisible: false,
            };
        },
        methods: {
            async geocode() {
                if (this.postCodeCorrect) {

                    this.addressVisible = false;

                    var res = await Api.shared.geocode(this.address.postcode);
                    if (res.result === GeocoderResults.match || res.result === GeocoderResults.partial) {
                        this.address.text = res.address.text;
                        this.address.postcode = res.address.postcode;
                        this.location.lat = res.location.lat;
                        this.location.lng = res.location.lng;
                        this.addressVisible = true;

                        if (res.result === GeocoderResults.partial) {
                            this.$notify({
                                timeout: 5500,
                                message: `We only found a partial match, are you sure the postcode was correct?`,
                                icon: "add_alert",
                                horizontalAlign: 'center',
                                verticalAlign: 'top',
                                type: NotyTypes[NotyTypes.warning]
                            });
                        } else {
                            this.$notify({
                                timeout: 7500,
                                message: `Match found, please confirm/complete the <b>street</b> address (inc numbers if appropriate) for <b>publication</b>`,
                                icon: "add_alert",
                                horizontalAlign: 'center',
                                verticalAlign: 'top',
                                type: NotyTypes[NotyTypes.success]
                            });
                        }
                    }
                    else {
                        this.address.text = null;

                        this.$notify({
                            timeout: 5500,
                            message: `Please only search for complete and correct postcodes`,
                            icon: "add_alert",
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: NotyTypes[NotyTypes.danger]
                        });
                    }
                }
            },
        },
        watch: {
            'address.postcode'() {
                this.$refs.validationProviderPostcode.validate().then(valResult => {
                    this.postCodeCorrect = (valResult.valid === true);
                });
            }
        },
        mounted() {
            if (this.address.text != null && this.address.text.length > 5) {
                this.addressVisible = true;
            }
        }
    }
</script>


<style lang="scss">
    .company-address {
        min-height: 250px;
    }
</style>



